<div class = "form-group row">

    <!-- <label class = "col-sm-2 col-form-label">Employee ID</label>
    <div class = "col-sm-10">
        <input type = "text" class = "form-control"
            [(ngModel)] = "fkEmpId"
            placeholder = "Enter Unique Employee ID">
    </div> -->

    <label class = "col-sm-2 col-form-label">Arrival</label>
    <div class = "col-sm-10">
        <input type = "text" class = "form-control"
            [(ngModel)] = "Arrival"
            placeholder="">
    </div>

     <label class = "col-sm-2 col-form-label">Departure</label>
    <div class = "col-sm-10">
        <input type = "text" class = "form-control"
            [(ngModel)] = "Departure">
    </div>

    <label class = "col-sm-2 col-form-label">Date</label>
    <div class = "col-sm-10">
        <input type = "text" class = "form-control"
            [(ngModel)] = "Date"
            placeholder ="mm-dd-yyyy">
    </div>

    <!-- <label class = "col-sm-2 col-form-label">Date</label>
    <div class="col-sm-10 inline">
        <input class="form-control"
            placeholder="yyyy-mm-dd"
            name="dp"
            [(ngModel)]="Date"
            ngbDatepicker #d="ngbDatepicker">
        <div class="input-group-append">
          <button class="btn btn-outline-secondary calendar inline"
            (click)="d.toggle()"
            type="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-day-fill" viewBox="0 0 16 16">
                <path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5h16v9zm-4.785-6.145a.428.428 0 1 0 0-.855.426.426 0 0 0-.43.43c0 .238.192.425.43.425zm.336.563h-.672v4.105h.672V8.418zm-6.867 4.105v-2.3h2.261v-.61H4.684V7.801h2.464v-.61H4v5.332h.684zm3.296 0h.676V9.98c0-.554.227-1.007.953-1.007.125 0 .258.004.329.015v-.613a1.806 1.806 0 0 0-.254-.02c-.582 0-.891.32-1.012.567h-.02v-.504H7.98v4.105z"/>
            </svg>
        </button>
        </div>
    </div> -->

    <!-- <label class = "col-sm-2 col-form-label">Date</label>
    <div class = "col-sm-10">
        <input class="form-control" placeholder="dd/mm/yyyy"
            name="d2" [(ngModel)]="Date" ngbDatepicker #d2="ngbDatepicker">
        <div class="input-group-append">
        <button class="btn btn-outline-secondary calendar" (click)="d2.toggle()" type="button"></button>
        </div>
    </div> -->


    <!-- <label class = "col-sm-2 col-form-label">DurationOfTasks</label>
    <div class = "col-sm-10">
        <input type = "text" class = "form-control"
            [(ngModel)] = "DurationOfTasks">
    </div> -->


<button (click) = "Test()"
    class = "btn btn-outline-success">
    Test
</button>

<button (click) = "AddAttendance()"  *ngIf = "attend.fkEmpId==0"
    class = "btn btn-outline-success">
    Add
</button>

<button (click) = "UpdateAttendance()"  *ngIf = "attend.fkEmpId!=0"
    class = "btn btn-outline-success">
    Update
</button>
